var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export function build(pages, predicate, homeTitle, homeUrl, logoUrl) {
    if (homeTitle === void 0) { homeTitle = ""; }
    if (homeUrl === void 0) { homeUrl = ""; }
    if (logoUrl === void 0) { logoUrl = ""; }
    return {
        home: {
            title: homeTitle,
            url: homeUrl
        },
        logoUrl: logoUrl,
        pages: predicate ? filter(clone(pages), predicate) : clone(pages)
    };
}
function clone(pages) {
    if (!pages)
        return [];
    return pages
        .map(function (p) { return __assign({}, p); })
        .map(function (p) { p.pages = clone(p.pages); return p; });
}
export function filter(pages, predicate) {
    var retArray = [];
    var i = 0;
    while (i < pages.length) {
        var page = pages[i];
        if (predicate(page)) {
            page.pages = filter(page.pages, predicate);
            retArray.push(page);
            i++;
        }
        else {
            pages.splice.bind(pages, i, 1).apply(pages, page.pages);
        }
    }
    return retArray;
}



//////////////////
// WEBPACK FOOTER
// ./src/Models/SiteMap.ts
// module id = 796
// module chunks = 24